<template>
  <div class="noticia">
    <div class="contenedor-imagen" v-if="el.list_img" :style="'background:url('+el.list_img.url+') center/cover no-repeat'">
      <img src="/static/img/icono-evento.svg" alt="Evento" class="evento" v-if="!!el.localizacion">
  </div>
  <div class="contenedor-imagen" v-else :style="'background:url('+el.img.url+') center/cover no-repeat'">
      <img src="/static/img/icono-evento.svg" alt="Evento" class="evento" v-if="!!el.localizacion">
  </div>
    <h2>{{el.titulo}}</h2>
    <!-- <h3>{{el.fecha.day}} de {{$t(`meses[${el.fecha.month-1}]`)}} {{el.fecha.year}}</h3> -->
    <p>{{el.entradilla}}</p>
    <router-link class="enlace-cover" :to="$t('enlaces.aldia')+'/'+el.slug">
    </router-link>
  </div>

</template>

<script>
  export default {
    name: 'evento',
    props: ['el'],
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue